var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadelmvpHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 52,
    viewBox: "0 0 270 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_12997)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_751_12997)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_751_12997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1093 5.04438C26.0579 5.04438 28.9079 5.4574 31.4316 6.54829C33.9595 7.61275 36.1416 9.30949 37.624 11.7446C37.6707 11.8213 37.7168 11.8987 37.7617 11.976C38.1126 12.5808 39.0125 12.648 39.3847 12.0561L41.9482 7.977L42.0576 7.80805C43.2199 6.08373 45.1666 5.04448 47.2548 5.04438H52.7099C55.4154 5.04438 57.8105 6.77951 58.6591 9.33833L58.6982 9.4604L61.7685 19.3891C62.0389 20.2635 63.3046 20.1729 63.4482 19.269L64.8691 10.3286L64.8925 10.187C65.4339 7.21586 68.0248 5.04461 71.0585 5.04438H81.3007C87.2219 5.04439 92.6184 6.41319 96.7197 9.90961C96.7255 9.91454 96.7314 9.91933 96.7372 9.92426C96.7395 9.92618 96.7418 9.92821 96.7441 9.93012L97.2079 10.3373C97.3595 10.4752 97.5081 10.6148 97.6533 10.7563C98.1112 11.2027 98.9199 10.9691 99.0195 10.3373L99.0439 10.1948C99.582 7.22 102.174 5.04456 105.211 5.04438H125.162C126.21 5.04441 127.191 5.29891 128.051 5.74653C128.349 5.90163 128.707 5.90237 129.005 5.74751C129.872 5.29702 130.855 5.04438 131.89 5.04438H138.439C142.29 5.04438 145.231 8.48387 144.632 12.2875L142.212 27.6479C142.13 28.1723 142.535 28.6469 143.066 28.6469H148.08C151.93 28.6471 154.869 32.085 154.271 35.8881L153.463 41.0317C152.983 44.08 150.356 46.3266 147.27 46.3266H127.323C126.274 46.3266 125.293 46.0707 124.433 45.6225C124.134 45.4672 123.776 45.4675 123.477 45.6225C122.61 46.0735 121.626 46.3266 120.591 46.3266H100.685C98.2258 46.3266 96.1377 44.9228 95.1064 42.9174C94.826 42.3722 94.1075 42.1303 93.5986 42.4721C92.2813 43.3568 90.8557 44.0962 89.3369 44.6957L89.3076 44.7065L89.2792 44.7182C86.3509 45.8356 83.1382 46.3266 79.7441 46.3266H66.4921C65.7512 46.3266 65.0443 46.1982 64.3896 45.9653C64.1691 45.8868 63.9275 45.8869 63.707 45.9653C63.0535 46.1978 62.3453 46.3266 61.5996 46.3266H55.5312C52.6705 46.3265 50.173 44.3892 49.4609 41.6186L49.2822 40.9243C49.184 40.5421 48.8389 40.2748 48.4443 40.2748H43.3593C43.0518 40.2748 42.7672 40.438 42.6122 40.7036L41.1484 43.2143C40.0254 45.1409 37.9633 46.3265 35.7333 46.3266H29.1923C24.2625 46.3265 21.2618 40.8972 23.8847 36.7231C24.1207 36.3468 23.8182 35.8598 23.3749 35.8891C22.7317 35.9317 22.0807 35.9516 21.4238 35.9516H20.5527C20.1275 35.9517 19.7657 36.2612 19.6992 36.6811L19.0087 41.0385C18.5266 44.0838 15.9015 46.3265 12.8183 46.3266H6.26947C2.4156 46.3265 -0.525597 42.8808 0.0790425 39.0747L4.64643 10.3286C5.13013 7.28506 7.75416 5.04461 10.8359 5.04438H23.1093Z",
    fill: "#304D95"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_751_12997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.705 10.6175H138.548C138.582 10.6177 138.609 10.6487 138.604 10.6829L134.968 33.762C134.93 34.0021 135.116 34.219 135.359 34.219H148.188C148.222 34.2192 148.248 34.2503 148.243 34.2845L147.233 40.7054C147.229 40.7328 147.206 40.7532 147.178 40.7532H125.936C125.901 40.7531 125.874 40.722 125.88 40.6878L130.649 10.6643C130.654 10.6372 130.678 10.6176 130.705 10.6175Z",
    fill: "url(#paint0_linear_751_12997)",
    stroke: "white",
    strokeWidth: 0.339181
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.026 10.6175H125.269C125.304 10.6176 125.33 10.6479 125.325 10.6819L124.401 16.5843C124.397 16.6118 124.373 16.6321 124.345 16.6321H110.943C110.748 16.6321 110.582 16.7739 110.552 16.9661L109.759 22.0042C109.721 22.2442 109.906 22.461 110.149 22.4612H122.416C122.45 22.4613 122.477 22.4924 122.471 22.5266L121.549 28.386C121.544 28.4133 121.521 28.4338 121.493 28.4339H109.041C108.846 28.4339 108.68 28.5748 108.649 28.7669L107.771 34.2796C107.733 34.5199 107.918 34.7376 108.162 34.7376H121.422C121.456 34.7376 121.483 34.7688 121.477 34.803L120.554 40.7054C120.55 40.7329 120.526 40.7532 120.498 40.7532H99.2996C99.2648 40.7532 99.2385 40.7221 99.2439 40.6878L103.97 10.6653C103.975 10.6379 103.998 10.6176 104.026 10.6175Z",
    fill: "url(#paint1_linear_751_12997)",
    stroke: "white",
    strokeWidth: 0.339181
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8743 10.6175H80.6614C85.7955 10.6175 89.7274 11.8076 92.4817 14.1643L92.4827 14.1653C95.2344 16.4917 96.6299 19.7122 96.6584 23.8489C96.6584 26.2799 96.2726 28.5364 95.5022 30.6194L95.5012 30.6204C94.7602 32.6723 93.6355 34.4519 92.1262 35.9612L92.1252 35.9622C90.645 37.4709 88.8209 38.6543 86.6506 39.511C84.484 40.3374 81.9697 40.7532 79.1047 40.7532H65.1047C65.0701 40.7531 65.0436 40.722 65.0491 40.6878L69.8186 10.6643C69.8231 10.6372 69.8467 10.6176 69.8743 10.6175ZM77.093 16.9778C76.8987 16.978 76.733 17.1199 76.7024 17.3118L74.051 33.9339C74.0127 34.1742 74.1992 34.3919 74.4426 34.3919H79.1917C80.6789 34.3919 81.9986 34.1588 83.1467 33.6878L83.1487 33.6868C84.324 33.1872 85.2971 32.48 86.0647 31.5647C86.8302 30.652 87.4029 29.5646 87.7834 28.3059L87.7825 28.305C88.1914 27.0184 88.3957 25.5756 88.3958 23.9778C88.3958 21.726 87.7508 19.9879 86.4377 18.7942C85.1268 17.5738 83.1912 16.9778 80.6614 16.9778H77.093Z",
    fill: "url(#paint2_linear_751_12997)",
    stroke: "white",
    strokeWidth: 0.339181
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4683 10.6175H53.4556C53.5795 10.6175 53.6885 10.6983 53.7251 10.8167L62.8696 40.387C62.9258 40.5688 62.7894 40.7532 62.5991 40.7532H55.4771C55.4514 40.7531 55.4288 40.7351 55.4224 40.7102L53.9546 34.9983C53.9096 34.8236 53.7522 34.7016 53.5718 34.7014H40.3286C40.1879 34.7014 40.0577 34.7762 39.9868 34.8977L36.5903 40.7249C36.5803 40.7422 36.5615 40.7531 36.5415 40.7532H28.8872C28.665 40.7532 28.53 40.5088 28.6479 40.3206L47.229 10.7493C47.2807 10.6671 47.3711 10.6175 47.4683 10.6175ZM49.5464 18.8802C49.4634 18.8802 49.3862 18.9239 49.3442 18.9954L44.0093 28.0901C43.8547 28.3539 44.0453 28.6858 44.3511 28.6858H51.7974C52.0568 28.6858 52.2462 28.4406 52.1802 28.1897L49.7729 19.055L49.7407 18.9837C49.6982 18.9203 49.626 18.8802 49.5464 18.8802Z",
    fill: "url(#paint3_linear_751_12997)",
    stroke: "white",
    strokeWidth: 0.339181
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 10.6174H23.5508C26.0432 10.6174 28.0936 10.9758 29.708 11.6838L29.71 11.6848C31.3247 12.3647 32.52 13.3511 33.3057 14.6418C34.0935 15.9362 34.4912 17.4898 34.4912 19.3088C34.4912 21.6774 34.0059 23.6931 33.0439 25.3625L33.043 25.3635C32.1116 27.0004 30.7001 28.2456 28.7988 29.0969H28.7979C26.9238 29.9488 24.615 30.3782 21.8652 30.3782H16.0264C15.7207 30.3784 15.4609 30.6016 15.4131 30.9036L13.8906 40.5149C13.8688 40.6521 13.7503 40.7532 13.6113 40.7532H6.22754C6.05397 40.7529 5.92198 40.5975 5.94922 40.426L10.6465 10.8557C10.6683 10.7184 10.7868 10.6174 10.9258 10.6174ZM18.1885 16.6321C17.8825 16.6321 17.6219 16.8552 17.5742 17.1575L16.5498 23.6448C16.4904 24.0221 16.782 24.3635 17.1641 24.3635H22.168C23.7175 24.3635 24.9174 24.0129 25.7383 23.2834L25.7412 23.2805C26.5629 22.5196 26.9628 21.4318 26.9629 20.0442C26.9629 18.9545 26.6331 18.1126 25.9521 17.551L25.8115 17.4426C25.0757 16.8921 23.9362 16.6321 22.4268 16.6321H18.1885Z",
    fill: "url(#paint4_linear_751_12997)",
    stroke: "white",
    strokeWidth: 0.339181
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.315 1.93114C257.434 1.93114 268.069 12.5663 268.069 25.6854C268.069 38.8044 257.434 49.4396 244.315 49.4396H182.901C169.782 49.4396 159.147 38.8044 159.147 25.6854C159.147 12.5663 169.782 1.93114 182.901 1.93114H244.315Z",
    fill: "url(#paint5_linear_751_12997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.314 0C258.5 5.91019e-06 269.999 11.4996 269.999 25.6853C269.999 39.871 258.5 51.3706 244.314 51.3706H182.901C168.715 51.3706 157.215 39.871 157.215 25.6853C157.215 11.4996 168.715 2.95471e-06 182.901 0H244.314ZM182.901 1.93109C169.782 1.93109 159.146 12.5662 159.146 25.6853C159.146 38.8044 169.782 49.4395 182.901 49.4395H244.314C257.433 49.4395 268.068 38.8044 268.068 25.6853C268.068 12.5662 257.433 1.93109 244.314 1.93109H182.901Z",
    fill: "url(#paint6_linear_751_12997)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.078,
    y: 3.86234,
    width: 105.059,
    height: 43.646,
    rx: 21.823,
    fill: "url(#paint7_linear_751_12997)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_751_12997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.142 38.1424C231.715 38.1424 231.369 37.7965 231.369 37.3699V14.5418C231.369 14.1152 231.715 13.7693 232.142 13.7693H243.089C244.933 13.7693 246.5 14.092 247.791 14.7373C249.081 15.3596 250.061 16.27 250.729 17.4685C251.421 18.6439 251.766 20.0729 251.766 21.7554C251.766 23.3918 251.421 24.8207 250.729 26.0423C250.061 27.2408 249.081 28.1627 247.791 28.808C246.5 29.4303 244.933 29.7414 243.089 29.7414H238.503C238.076 29.7414 237.73 30.0873 237.73 30.5139V37.3699C237.73 37.7965 237.384 38.1424 236.958 38.1424H232.142ZM237.73 24.0943C237.73 24.521 238.076 24.8668 238.503 24.8668H241.983C243.181 24.8668 244.103 24.6133 244.748 24.1063C245.394 23.5762 245.716 22.7925 245.716 21.7554C245.716 20.6952 245.394 19.9116 244.748 19.4045C244.103 18.8975 243.181 18.6439 241.983 18.6439H238.503C238.076 18.6439 237.73 18.9898 237.73 19.4164V24.0943Z",
    fill: "url(#paint8_linear_751_12997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.142 38.1424C231.715 38.1424 231.369 37.7965 231.369 37.3699V14.5418C231.369 14.1152 231.715 13.7693 232.142 13.7693H243.089C244.933 13.7693 246.5 14.092 247.791 14.7373C249.081 15.3596 250.061 16.27 250.729 17.4685C251.421 18.6439 251.766 20.0729 251.766 21.7554C251.766 23.3918 251.421 24.8207 250.729 26.0423C250.061 27.2408 249.081 28.1627 247.791 28.808C246.5 29.4303 244.933 29.7414 243.089 29.7414H238.503C238.076 29.7414 237.73 30.0873 237.73 30.5139V37.3699C237.73 37.7965 237.384 38.1424 236.958 38.1424H232.142ZM237.73 24.0943C237.73 24.521 238.076 24.8668 238.503 24.8668H241.983C243.181 24.8668 244.103 24.6133 244.748 24.1063C245.394 23.5762 245.716 22.7925 245.716 21.7554C245.716 20.6952 245.394 19.9116 244.748 19.4045C244.103 18.8975 243.181 18.6439 241.983 18.6439H238.503C238.076 18.6439 237.73 18.9898 237.73 19.4164V24.0943Z",
    fill: "url(#paint9_radial_751_12997)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.562 38.1424C214.259 38.1424 213.984 37.9655 213.859 37.69L203.465 14.8619C203.232 14.3504 203.606 13.7693 204.168 13.7693H209.235C209.543 13.7693 209.822 13.9529 209.944 14.2362L217.312 31.3416C217.493 31.7621 217.185 32.2306 216.727 32.2306C216.269 32.2306 215.961 31.7621 216.142 31.3416L223.509 14.2362C223.631 13.9529 223.91 13.7693 224.219 13.7693H229.042C229.605 13.7693 229.979 14.3512 229.745 14.8627L219.319 37.6908C219.193 37.9659 218.918 38.1424 218.616 38.1424H214.562Z",
    fill: "url(#paint10_linear_751_12997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.562 38.1424C214.259 38.1424 213.984 37.9655 213.859 37.69L203.465 14.8619C203.232 14.3504 203.606 13.7693 204.168 13.7693H209.235C209.543 13.7693 209.822 13.9529 209.944 14.2362L217.312 31.3416C217.493 31.7621 217.185 32.2306 216.727 32.2306C216.269 32.2306 215.961 31.7621 216.142 31.3416L223.509 14.2362C223.631 13.9529 223.91 13.7693 224.219 13.7693H229.042C229.605 13.7693 229.979 14.3512 229.745 14.8627L219.319 37.6908C219.193 37.9659 218.918 38.1424 218.616 38.1424H214.562Z",
    fill: "url(#paint11_radial_751_12997)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.528 38.1424C176.102 38.1424 175.756 37.7965 175.756 37.3699V14.5418C175.756 14.1152 176.102 13.7693 176.528 13.7693H180.592C180.872 13.7693 181.13 13.9207 181.266 14.1651L189.151 28.2793C189.283 28.5162 189.112 28.808 188.841 28.808C188.57 28.808 188.398 28.5167 188.53 28.2798L196.382 14.1663C196.518 13.9212 196.776 13.7693 197.057 13.7693H200.981C201.408 13.7693 201.754 14.1152 201.754 14.5418V37.3699C201.754 37.7965 201.408 38.1424 200.981 38.1424H196.787C196.361 38.1424 196.015 37.7965 196.015 37.3699V23.9225C196.015 23.7758 196.134 23.6568 196.281 23.6568C196.485 23.6568 196.613 23.8783 196.511 24.0554L190.672 34.1609C190.534 34.3998 190.279 34.5469 190.003 34.5469H187.438C187.162 34.5469 186.907 34.3994 186.769 34.16L180.951 24.0589C180.839 23.8647 180.979 23.6223 181.203 23.6223C181.364 23.6223 181.495 23.7527 181.495 23.9135V37.3699C181.495 37.7965 181.149 38.1424 180.722 38.1424H176.528Z",
    fill: "url(#paint12_linear_751_12997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.528 38.1424C176.102 38.1424 175.756 37.7965 175.756 37.3699V14.5418C175.756 14.1152 176.102 13.7693 176.528 13.7693H180.592C180.872 13.7693 181.13 13.9207 181.266 14.1651L189.151 28.2793C189.283 28.5162 189.112 28.808 188.841 28.808C188.57 28.808 188.398 28.5167 188.53 28.2798L196.382 14.1663C196.518 13.9212 196.776 13.7693 197.057 13.7693H200.981C201.408 13.7693 201.754 14.1152 201.754 14.5418V37.3699C201.754 37.7965 201.408 38.1424 200.981 38.1424H196.787C196.361 38.1424 196.015 37.7965 196.015 37.3699V23.9225C196.015 23.7758 196.134 23.6568 196.281 23.6568C196.485 23.6568 196.613 23.8783 196.511 24.0554L190.672 34.1609C190.534 34.3998 190.279 34.5469 190.003 34.5469H187.438C187.162 34.5469 186.907 34.3994 186.769 34.16L180.951 24.0589C180.839 23.8647 180.979 23.6223 181.203 23.6223C181.364 23.6223 181.495 23.7527 181.495 23.9135V37.3699C181.495 37.7965 181.149 38.1424 180.722 38.1424H176.528Z",
    fill: "url(#paint13_radial_751_12997)",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_751_12997",
    x: -4.65784,
    y: 1.81972,
    width: 163.665,
    height: 50.5979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.43318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32892
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_751_12997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_751_12997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_751_12997",
    x: 0,
    y: 4.81826,
    width: 154.349,
    height: 41.7345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.339181
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.11306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_751_12997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.226121
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.282651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.126966 0 0 0 0 0.2478 0 0 0 0 0.547799 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_751_12997",
    result: "effect2_innerShadow_751_12997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_751_12997",
    x: 5.09727,
    y: 10.4475,
    width: 143.768,
    height: 31.7189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.11306,
    dy: 0.678363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.282651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108852 0 0 0 0 0.23178 0 0 0 0 0.536983 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_751_12997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_751_12997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_751_12997",
    x: 175.756,
    y: 13.3831,
    width: 76.0105,
    height: 25.5318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.772495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_751_12997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.386248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.74902 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_751_12997",
    result: "effect2_dropShadow_751_12997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_751_12997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_751_12997",
    x1: 137.061,
    y1: 10.4475,
    x2: 137.061,
    y2: 40.9228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_751_12997",
    x1: 112.284,
    y1: 10.4475,
    x2: 112.284,
    y2: 40.9228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_751_12997",
    x1: 80.8342,
    y1: 10.4475,
    x2: 80.8342,
    y2: 40.9228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_751_12997",
    x1: 45.6407,
    y1: 10.4475,
    x2: 45.6407,
    y2: 40.9228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_751_12997",
    x1: 20.1794,
    y1: 10.4475,
    x2: 20.1794,
    y2: 40.9227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_751_12997",
    x1: 213.608,
    y1: 1.93114,
    x2: 213.608,
    y2: 49.4396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_751_12997",
    x1: 213.607,
    y1: 1.93109,
    x2: 213.607,
    y2: 49.4395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_751_12997",
    x1: 213.151,
    y1: 3.86234,
    x2: 213.151,
    y2: 47.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DE7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F4D683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F4CA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_751_12997",
    x1: 241.568,
    y1: 13.7693,
    x2: 241.568,
    y2: 38.1424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_751_12997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.98087 -23.5611 2.02731 9.53646 237.536 37.659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_751_12997",
    x1: 216.606,
    y1: 13.7693,
    x2: 216.606,
    y2: 38.1424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_751_12997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.6727 -23.5611 2.7111 9.53646 211.214 37.659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_751_12997",
    x1: 188.755,
    y1: 13.7693,
    x2: 188.755,
    y2: 38.1424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_751_12997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.1722 -23.5611 2.58396 9.53646 183.616 37.659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_12997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 51.3706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadelmvpHorizontal);
export default __webpack_public_path__ + "static/media/padelmvp_horizontal.95fbd2c7153f601071f96ddcb13c9cb1.svg";
export { ForwardRef as ReactComponent };